import { useId, type ReactElement } from 'react';

// Campo de texto largo (motivos, notas) con su error y su ayuda enlazados, igual que
// TextField: aria-invalid + aria-describedby, sin que cambie el nombre del campo.

export function TextAreaField({
  label,
  value,
  onChange,
  error,
  maxLength,
  placeholder,
  hint,
  rows = 3,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error: string | null;
  maxLength: number;
  placeholder?: string;
  hint?: string;
  rows?: number;
}): ReactElement {
  const id = useId();
  const errorId = `${id}-err`;
  const hintId = `${id}-hint`;
  const describedBy =
    [error === null ? null : errorId, hint === undefined ? null : hintId]
      .filter((x) => x !== null)
      .join(' ') || undefined;
  return (
    <div className="fld">
      <label htmlFor={id} className="fld-lab">
        {label}
      </label>
      <textarea
        id={id}
        className="selector fw"
        value={value}
        rows={rows}
        maxLength={maxLength}
        placeholder={placeholder}
        aria-invalid={error !== null}
        aria-describedby={describedBy}
        onChange={(e) => onChange(e.target.value)}
      />
      {error !== null && (
        <span id={errorId} className="fld-err">
          {error}
        </span>
      )}
      {hint !== undefined && (
        <span id={hintId} className="fld-hint">
          {hint}
        </span>
      )}
    </div>
  );
}
